const wx = require('./1.3.2.js').wx

const plugin = {
  install (Vue) {
    Vue.prototype.$wechat = wx
    Vue.wechat = wx
  },
  $wechat: wx
}

export default plugin
export const install = plugin.install



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/plugins/wechat/index.js